<template>
  <div v-if="store.loaded && !store.showMobile" class="wrapper">
    <nav>
      <template v-for="item in store.menu" :key="item.id">
        <router-link :to="'/' + item.id" class="container">
          <div v-html="item.text" class="menu-item"/>
          <div class="red-bar-container">
            <div :class="['red-bar', {'red-bar-visible': $route.params.category === item.id}]"/>
          </div>
        </router-link>
      </template>
    </nav>
    <div class="text-wrapper">
      <router-link to="/about" :class="['text', { 'hide-text': $route.name === 'about'}]">
        Мы делаем фильмы, ролики, аудио, графику, анимацию, но мы отчетливо понимаем, что… реклама — это прежде всего идея, поэтому…
      </router-link>
    </div>
  </div>    
  <!-- ================ -->
  <!-- Мобильная версия -->
  <!-- ================ -->
  <template v-if="store.loaded && store.showMobile">
    <div
      class="mobile-wrapper"
      @click="isMobileMenuActive = true"
    >
      <img src="/images/icon_dots_menu.svg" class="dots-menu">
    </div>
    <div :class="['mobile-menu', {'mobile-menu-active': isMobileMenuActive}]">
      <nav class="mobile-nav">
        <template v-for="item in [...store.menu, ...[{id: 'about', text: 'Кто мы?'}]]" :key="item.id">
          <router-link :to="'/' + item.id" @click="isMobileMenuActive = false" class="container">
            <div v-html="item.text" class="mobile-menu-item"/>
            <div class="mobile-red-bar-container">
              <div :class="['red-bar', {'red-bar-visible': ($route.params.category === item.id) || $route.name === item.id} ]"/>
            </div>
          </router-link>
        </template>
      </nav>
      <span v-if="isMobileMenuActive" @click="isMobileMenuActive = false" class="dots-menu mobile-link"><img src="/images/icon_plus.svg" class="mobile-icon"></span>
    </div>
  </template>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useMainStore } from '../store'
export default defineComponent({
  name: 'MenuBlock',
  data () {
    return {
      store: useMainStore(),
      isMobileMenuActive: false
    }
  }
})
</script>

<style scoped>

.wrapper {
  position: relative;
  display: grid;
  grid-template-rows: 4fr 1fr;
  /* width: 30rem; */
  height: 100%;
  min-height: 40rem;
  padding: 5rem;
}

nav {
  pointer-events: all;
  /* width: 30rem; */
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  height: fit-content;
}

.container {
  position: relative;
  display: grid;
  grid-template-rows: auto .3rem;
  gap: 1rem;
}

.container:active .underline {
  width: 100%;
  transition: all .3s ease-in-out;
}

.menu-item {
  font-size: .8rem;
}

.underline {
  width: 0;
  height: 100%;
  background-color: var(--font_color);
  transition: all .3s ease-in-out;
}

.red-bar-container {
  pointer-events: none;
  position: absolute;
  width: 9rem;
  height: 20rem;
  bottom: 0rem;
  left: .5rem;
  transform: rotate(7deg);
  z-index: -1;
}

.red-bar {
  width: 100%;
  height: 0;
  background-color: var(--red);
  transition: all .7s cubic-bezier(0.075, 0.82, 0.165, 1);
}

.red-bar-visible {
  height: 20rem;
  transition: all .7s cubic-bezier(0.075, 0.82, 0.165, 1);
}

.text {
  pointer-events: all;
  font-size: .8rem;
  display: grid;
  align-items: end;
  transition: all .5s ease-in-out;
}

.text-wrapper {
  display: flex;
}

.hide-text {
  pointer-events: none;
  opacity: 0;
  transition: all .5s ease-in-out;
}

/* ================ */
/* Мобильная версия */
/* ================ */
.dots-menu {
  position: absolute;
  cursor: pointer;
  top: 0;
  right: 0;
  width: 6rem;
  padding: 1.5rem;
}

.mobile-link {
  position: fixed;
  pointer-events: all;
  z-index: 1;
}

.mobile-icon {
  height: 3rem;
  transform: rotate(45deg);
}

.mobile-menu {
  pointer-events: none;
  position: fixed;
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow-y: auto;  
  background-color: var(--background_color);
  bottom: 100%;
  transition: all .5s ease-in-out;
}

.mobile-menu-active {
  pointer-events: all;
  bottom: 0;
  transition: all .5s ease-in-out;
}

.mobile-red-bar-container {
  pointer-events: none;
  position: absolute;
  width: 6rem;
  height: 23rem;
  top: -9rem;
  left: 0.5rem;
  transform: rotate(-93deg);
  z-index: -1;
}

.mobile-nav {
  grid-template-columns: none;
  grid-template-rows: repeat(auto-fit, 1fr);
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 3rem;
  overflow-y: auto;
}

.mobile-menu-item {
  font-size: 2rem;
}

</style>